
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/yundongyuan/options',
  yundongyuanList: '/adminapi/yundongyuan/yundongyuanList',
  yundongyuanDetail: '/adminapi/yundongyuan/yundongyuandetail',
  yundongyuanEdit: '/adminapi/yundongyuan/yundongyuanedit',
  yundongyuanDelete: '/adminapi/yundongyuan/yundongyuandelete',
  levelApplyList: '/adminapi/yundongyuan/levelApplyList',
  levelApplyDetail: '/adminapi/yundongyuan/levelApplyDetail',
  editLevelApply: '/adminapi/yundongyuan/levelApplyEdit',
  deleteLevelApply: '/adminapi/yundongyuan/levelApplyDelete',

  levelApplyMemberList: '/adminapi/yundongyuan/levelApplyMemberList',
  levelApplyMemberDetail: '/adminapi/yundongyuan/levelApplyMemberDetail',
  editLevelApplyMember: '/adminapi/yundongyuan/levelApplyMemberEdit',
  deleteLevelApplyMember: '/adminapi/yundongyuan/levelApplyMemberDelete',

  levelSpApply: '/adminapi/yundongyuan/levelSpApply',
  levelSpApplyMemberList: '/adminapi/yundongyuan/levelSpApplyMemberList',
  levelSpApplyList: '/adminapi/yundongyuan/levelSpApplyList',
  levelSpApplyDetail: '/adminapi/yundongyuan/levelSpApplyDetail',
  editLevelSpApply: '/adminapi/yundongyuan/levelSpApplyEdit',
  deleteLevelSpApply: '/adminapi/yundongyuan/levelSpApplyDelete',

  levelSpApplyMemberDetail: '/adminapi/yundongyuan/levelApplySpMemberDetail',
  editLevelSpApplyMember: '/adminapi/yundongyuan/levelApplySpMemberEdit',
  deleteLevelSpApplyMember: '/adminapi/yundongyuan/levelApplySpMemberDelete',
  levelSpShenhe: '/adminapi/yundongyuan/levelSpShenhe',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}


export function getYundongyuanList(parameter) {
  return axios({
    url: api.yundongyuanList,
    method: 'get',
    params: parameter
  })
}

export function getYundongyuanDetail(parameter) {
  return axios({
    url: api.yundongyuanDetail,
    method: 'get',
    params: parameter
  })
}

export function editYundongyuan(parameter) {
  return axios({
    url: api.yundongyuanEdit,
    method: 'post',
    data: parameter
  })
}

export function deleteYundongyuan(parameter) {
  return axios({
    url: api.yundongyuanDelete,
    method: 'post',
    data: parameter
  })
}

export function getLevelApplyMemberList(parameter) {
  return axios({
    url: api.levelApplyMemberList,
    method: 'get',
    params: parameter
  })
}

export function getLevelSpApplyMemberList(parameter) {
  return axios({
    url: api.levelSpApplyMemberList,
    method: 'get',
    params: parameter
  })
}
export function getLevelSpApplyList(parameter) {
  return axios({
    url: api.levelSpApplyList,
    method: 'get',
    params: parameter
  })
}

export function getLevelApplyMemberDetail(parameter) {
  return axios({
    url: api.levelApplyMemberDetail,
    method: 'get',
    params: parameter
  })
}

export function editLevelApplyMember(parameter) {
  return axios({
    url: api.editLevelApplyMember,
    method: 'post',
    data: parameter
  })
}

export function levelSpApply(parameter) {
  return axios({
    url: api.levelSpApply,
    method: 'post',
    data: parameter
  })
}
export function levelSpShenhe(parameter) {
  return axios({
    url: api.levelSpShenhe,
    method: 'post',
    data: parameter
  })
}

export function deleteLevelApplyMember(parameter) {
  return axios({
    url: api.deleteLevelApplyMember,
    method: 'post',
    data: parameter
  })
}


export function getLevelApplyList(parameter) {
  return axios({
    url: api.levelApplyList,
    method: 'get',
    params: parameter
  })
}

export function getLevelApplyDetail(parameter) {
  return axios({
    url: api.levelApplyDetail,
    method: 'get',
    params: parameter
  })
}

export function editLevelApply(parameter) {
  return axios({
    url: api.editLevelApply,
    method: 'post',
    data: parameter
  })
}

export function deleteLevelApply(parameter) {
  return axios({
    url: api.deleteLevelApply,
    method: 'post',
    data: parameter
  })
}

export function getLevelSpApplyDetail(parameter) {
  return axios({
    url: api.levelSpApplyDetail,
    method: 'get',
    params: parameter
  })
}

export function editLevelSpApply(parameter) {
  return axios({
    url: api.editLevelSpApply,
    method: 'post',
    data: parameter
  })
}

export function deleteLevelSpApply(parameter) {
  return axios({
    url: api.deleteLevelSpApply,
    method: 'post',
    data: parameter
  })
}


export function getLevelSpApplyMemberDetail(parameter) {
  return axios({
    url: api.levelSpApplyMemberDetail,
    method: 'get',
    params: parameter
  })
}

export function editLevelSpApplyMember(parameter) {
  return axios({
    url: api.editLevelSpApplyMember,
    method: 'post',
    data: parameter
  })
}
export function deleteLevelSpApplyMember(parameter) {
  return axios({
    url: api.deleteLevelSpApplyMember,
    method: 'post',
    data: parameter
  })
}
